import { ActionTypes as ChatActionTypes } from 'chat_v2/constants/ChatConstants';
import { ActionTypes as RelationshipActionTypes } from 'constants/RelationshipConstants';
import { ActionTypes as ChatSettingsActionTypes } from 'settings/constants/ChatSettingsConstants';
import Chat from 'entities/Chat';
import ChatMember from 'entities/ChatMember';
import ChatMembers from 'collections/ChatMembers';
// @ts-ignore
import PotentialChatMember from 'entities/PotentialChatMember';
import CurrentUser from 'auth/CurrentUser';
import Store from 'lib/Store';
import { Backbone$Id } from 'types/typescript/Backbone';
// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class ChatMemberStore extends Store {
  getInitialState() {
    return {
      chatMembers: new ChatMembers(),
    };
  }

  getMember(memberId: Backbone$Id): ChatMember {
    return this.state.chatMembers.get(memberId);
  }

  loadChatMembers(chat: Chat): void {
    chat.getMemberships().forEach(membership => {
      this.state.chatMembers.add(membership.getMember());
    });
  }

  loadMembers(members: (ChatMember | PotentialChatMember)[]): void {
    members.forEach(member => {
      // Cast PotentialChatMembers so ChatMemberStore only holds ChatMembers
      const chatMember = member instanceof ChatMember ? member : new ChatMember(member.attributes);
      this.state.chatMembers.add(chatMember);
    });
  }

  handleDispatch(action: any): void {
    switch (action.type) {
      case ChatActionTypes.LIST_CHATS:
      case ChatActionTypes.APPEND_CHATS:
        action.chats.map((chat: Chat) => this.loadChatMembers(chat));
        this.emitChange();
        break;
      case ChatActionTypes.LOAD_CHAT:
      case ChatActionTypes.CREATE_CHAT:
        this.loadChatMembers(action.chat);
        this.emitChange();
        break;
      case ChatActionTypes.LOAD_LOCAL_CHAT:
        this.loadMembers(action.members);
        this.emitChange();
        break;
      case RelationshipActionTypes.LOAD_RELATIONSHIP:
      case RelationshipActionTypes.UPDATE_RELATIONSHIP:
        break;
      case ChatSettingsActionTypes.OFFICE_HOURS_LOADED:
      case ChatSettingsActionTypes.OFFICE_HOURS_ENABLED:
      case ChatSettingsActionTypes.OFFICE_HOURS_DISABLED:
      case ChatSettingsActionTypes.OFFICE_HOURS_UPDATED: {
        const member = this.state.chatMembers.get(CurrentUser.getUser().id);
        if (member && member.setOfficeHours) {
          member.setOfficeHours(action.hours);
        }
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }
}

export default new ChatMemberStore();
